/* External dependencies */
import { API } from 'aws-amplify';

/* Internal dependencies */
import { ApiName } from '../aws-exports';

export const listPrompts = async (limit: number = 30) =>
  await API.get(ApiName.bmApp, `/prompts`, {
    queryStringParameters: { limit },
  });